'use strict';

export class HorizontalTabs {
  constructor() {
    $('.horizontal-tabs ul.horizontal-tabs-list li a').on('click', function(){
        var href = $(this).attr('href');
        history.pushState({}, '', href);
    })
  }
}
